<template>
    <div class="form-row">
        <BFormGroup label="Назва компанії" :state="validCompany" class="col-md-6 mt-3">
            <BFormInput id="company" v-model="form.company" :state="validCompany" required/>
            <BFormInvalidFeedback>
                Назва компанії повинна бути не менше 3 символів
            </BFormInvalidFeedback>
        </BFormGroup>
        
        <BFormGroup label="Код ЄДРПОУ компанії" :state="validErdpou" class="col-md-3  mt-3">
            <BFormInput id="erdpoy-input-group" v-model="form.erdpoy" :state="validErdpou" required/>
            <BFormInvalidFeedback>
                Поле Код ЄДРПОУ компанії повинно бути заповнене
            </BFormInvalidFeedback>
        </BFormGroup>
        
        <yes_no
            v-model="form.pdv"
            base_class="mt-3 pl-5"
            title="Вкажіть чи є організація платником ПДВ"
            :radio_options="PdvOptions"
        >
        </yes_no>
        
        <BFormGroup label="Контактна особа" :state="validContUser" class="col-md-6  mt-3">
            <BFormInput id="contuser-input-group" v-model="form.contuser" :state="validContUser" required/>
            <BFormInvalidFeedback>
                Поле Контактна особа повинно бути заповнене
            </BFormInvalidFeedback>
        </BFormGroup>
        
        <BFormGroup label="Контактний номер телефону" :state="validPhone" class="col-md-6  mt-3">
            <BFormInput
                type="mobile"
                v-mask="'+38 (###) ###-##-##'"
                placeholder="+38 (###) ###-##-##"
                id="mobile-input-group"
                v-model="form.mobile"
                :state="validPhone" required/>
            
            <BFormInvalidFeedback>
                Поле Контактний номер телефону має бути принаймні 8 символів
            </BFormInvalidFeedback>
        </BFormGroup>
        
        <BFormGroup label="Адреса електронної пошти" :state="validEmail" class="col-md-6  mt-3">
            <BFormInput id="email-input-group" v-model="form.email" :state="validEmail" required/>
            <BFormInvalidFeedback>
                Поле E-mail повинно бути заповнене
            </BFormInvalidFeedback>
        </BFormGroup>
        
        <BFormGroup label="Пароль" :state="validPassword" class="col-md-6  mt-3">
            <BFormInput id="password-input-group" type="password" v-model="form.password" :state="validPassword" required/>
            <BFormInvalidFeedback>
                Поле Пароль повинно бути заповнене
            </BFormInvalidFeedback>
        </BFormGroup>
        
        <div class="col-12 mt-3">
            <user_subscribe v-model="form.subscribes"></user_subscribe>
        </div>
        
        <div class="col-12 mt-3">
            <BButton size="lg" @click="register" variant="outline-primary" :disabled="!isValidRegister">Зареєструватись</BButton>
        </div>
    </div>
</template>

<script>
import {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormRadioGroup,
} from 'bootstrap-vue-next';

import Yes_no from "../../../base/yes_no.vue";
import User_subscribe from "../subscribe/user_subscribe.vue";

export default {
    name: 'user_register',
    components: {
        User_subscribe,
        Yes_no,
        BForm,
        BFormGroup,
        BFormInput,
        BFormInvalidFeedback,
        BButton,
        BFormRadioGroup,
    },
    
    data() {
        return {
            form: {
                erdpoy: null,
                company: null,
                mobile: null,
                contuser: null,
                email: null,
                password: null,
                pdv: null,
                subscribes: [],
            },
            
            submitted: false,
            is_loading : false
        };
    },
 
    methods: {
        async register() {
            if (this.form.subscribes.length <=  0) {
                EventBus.$emit('show_toast', {err: 'Виберіть категорії тендерів, які Вас цікавлять!', type: "danger", title: 'Помилка'});
                return false;
            }
            
            this.is_loading = true;
            IMC_CORE.showloading();
            
            axios
                .post('/internal/user/user_register', this.form)
                .then(({ data }) => {
                    this.is_loading = false;
                    EventBus.$emit('show_toast', {
                        err: data.message,
                        type: 'success',
                        title: 'Вітаємо',
                    });
                    
                    IMC_CORE.hideloading();
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 1000);
                    
                })
                .catch((err) => {
                    this.is_loading = false;
                    EventBus.$emit('show_toast', {
                        err: err.message,
                        type: 'danger',
                        title: err.name,
                    });
                });
        },
        
        onSubmit() {
            this.submitted = true;
            
            
            
            if (this.validCompany && this.form.subscribes.length > 0) {
                
                if (this.form.subscribes.length === 0) {
                    EventBus.$emit('show_toast', {err: 'Виберіть категорії тендерів, які Вас цікавлять!', type: "danger", title: 'Помилка'});
                    
                }
                
                axios
                    .post('/index.php?option=com_tenders&task=api.register', data)
                    .then(({ data }) => {
                        if (data.status === 'operation_success') {
                            EventBus.$emit('show_toast', {
                                err: data.message,
                                type: 'success',
                                title: 'Вітаємо',
                            });
                        } else {
                            EventBus.$emit('show_toast', {
                                err: data.errors,
                                type: 'danger',
                                title: 'Помилка',
                            });
                        }
                    })
                    .catch((err) => {
                        EventBus.$emit('show_toast', {
                            err: err.message,
                            type: 'danger',
                            title: err.name,
                        });
                    });
            } else {
                if (this.form.subscribes.length === 0) {
                    EventBus.$emit('show_toast', {
                        err: 'Виберіть категорії тендерів, які Вас цікавлять!',
                        type: 'danger',
                        title: 'Помилка',
                    });
                }
            }
        },
    },
    
    computed: {
        
        isValidRegister() {
            if(!this.validCompany) {
                return false;
            }
            
            if(!this.validErdpou) {
                return false;
            }
            
            if (!this.validContUser) {
                return false;
            }
            
            if(!this.validEmail) {
                return false;
            }
            
            if(!this.validPassword) {
                return false;
            }
            
            if(!this.validPdv) {
                return false;
            }
            
            
            
            
            return true;
        },
        
        validCompany() {
            return this.form.company?.length >= 3;
        },
        
        validErdpou() {
            return this.form.erdpoy?.length >= 8;
        },
        
        validContUser() {
            return this.form.contuser?.length >= 3;
        },
        
        validPhone() {
            return this.form.mobile?.length >= 8;
        },
        
        validEmail() {
            const email = this.form.email;
            const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return pattern.test(email);
        },
        
        validPassword() {
            return this.form.password?.length >= 6;
        },
        
        validPdv() {
            return this.form.pdv?.length >= 1;
        },
        
        PdvOptions() {
            return [
                {value: '1', text: 'Платник ПДВ'},
                {value: '2', text: 'Ні'},
            ];
        },
        
        
    },
};
</script>